import { useSyncExternalStore } from 'react';

import authSessionService, { type AuthSession, type IAuth } from 'services/authSession';
import { type User } from 'services/user/types';

export function useAuthSession(): AuthSession {
  return useSyncExternalStore(
    authSessionService.subscribe.bind(authSessionService),
    authSessionService.getSnapshot.bind(authSessionService),
    authSessionService.getSnapshot.bind(authSessionService)
  );
}

export function useAuthSessionUser(): User | null | undefined {
  return useAuthSession().user ?? undefined;
}

export function useAuthSessionTokens(): IAuth | null | undefined {
  return useAuthSession().tokens ?? undefined;
}
